import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import '@fortawesome/fontawesome-free/css/all.min.css';

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);